const QuoteTypeNameConstants: { [key: number]: any } = {
  0: 'Surgical',
  1: 'Non-Surgical',
  2: 'Injection',
  3: 'Post-Surgical',
  4: 'Post-Injection',
}
export default QuoteTypeNameConstants
